import { Button, Form, Input, message, Select } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import { EnumMedicineCategory } from 'src/constants/enum';
import { ConfigOrderType, EnumOrderType } from 'src/constants/Order';
import { ITranslate } from 'src/entity/BasicEntity';
import { IMallBrand, IMallCategory, IMallPharmacyDetail } from 'src/entity/MallEntity';
import { fetchMallBrandIfNeeded } from 'src/redux/actions/mallBrandCreator';
import { fetchMallCategoryIfNeeded } from 'src/redux/actions/mallCategoryCreator';
import { reloadMallPharmacy } from 'src/redux/actions/mallPharmacyCreator';
import I18N from 'src/services/I18NService';
import { MallService, MallMedicineType } from 'src/services/MallService';
import { OrderTypeList } from 'src/services/PromotionService';

interface IPharmacyAddFormProps extends FormComponentProps, RouteComponentProps {
  categoryList: IMallCategory[];
  isAgent: boolean;
  brandList: IMallBrand[];
  dispatch: Dispatch<any>;
}

interface IPharmacyAddState {
  loading: boolean;
}

class PharmacyAddForm extends React.Component<IPharmacyAddFormProps, IPharmacyAddState> {
  constructor(props: IPharmacyAddFormProps) {
    super(props);

    this.state = {
      loading: false,
    } as IPharmacyAddState;
  }

  async componentDidMount() {
    await this.props.dispatch(fetchMallCategoryIfNeeded());
    await this.props.dispatch(fetchMallBrandIfNeeded());
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  goback = () => {
    this.props.history.goBack();
  };

  /**
   * 获取默认剂型
   *
   * @memberof PharmacyAddForm
   */
  defaultDosageForm = (categoryCode?: string) => {
    const medicineTypeList = this.getMedicineTypeList(categoryCode);
    if (medicineTypeList.length > 0) {
      // return medicineTypeList[0].value;
    }
    return undefined;
  };

  /**
   * 切换类目，修改剂型内容
   *
   * @memberof PharmacyAddForm
   */
  categoryOnChange = (categoryCode: string) => {
    this.props.form.setFieldsValue({
      dosage_form: this.defaultDosageForm(categoryCode),
      order_type: undefined,
    });
  };

  /**
   * 获取剂型选择项
   *
   * @memberof PharmacyAddForm
   */
  getMedicineTypeList = (categoryCode?: string) => {
    let medicineTypeList = MallMedicineType;

    const { categoryList } = this.props;
    if (!categoryCode) {
      categoryCode = this.props.form.getFieldValue('category');
    }

    const categoryObj = categoryList.find((t) => t.code === categoryCode);
    if (!!categoryObj) {
      medicineTypeList = MallMedicineType.filter((t) => t.category === categoryObj.code);
    }

    return medicineTypeList;
  };


  /** 获取订单类型 */
  getOrderTypeList = (categoryCode?: string) => {
    const orderTypeList: ITranslate[] = ConfigOrderType;
    if (!categoryCode) {
      categoryCode = this.props.form.getFieldValue('category');
    }
    // if(categoryCode === EnumMedicineCategory.中成药) {
    //   orderTypeList = [ConfigOrderType[0]];
    // } 
    return orderTypeList;
  }

  /**
   * 提交
   *
   * @memberof PharmacyAddForm
   */
  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values: Partial<IMallPharmacyDetail>) => {
      if (!err) {
        if (this.state.loading) {
          return;
        }
        try {
          this.setState({
            loading: true,
          });
          const param: Partial<IMallPharmacyDetail> = {
            ...values,
            active_conditional: !this.props.isAgent,
          };
          const res = await MallService.createPharmacy(param);
          if (!!res && !!res.uuid) {
            message.success(I18N.get('common_save_success'));
            this.props.form.resetFields();
            this.props.dispatch(reloadMallPharmacy());
          }
        } catch (error) {
          if (!!error.response) {
            if (error.response.data.error_code === 2002) {
              if (values.category === 'CPM') {
                message.error(I18N.get('err_save_has_only_cpm'));
              } else {
                message.error(I18N.get('err_save_name_repeat_tcm'));
              }
            } else {
              message.error(JSON.stringify(error.response.data));
            }
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        } finally {
          this.setState({
            loading: false,
          });
        }
      }
    });
  };

  render() {
    const { categoryList, brandList } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 6 },
      wrapperCol: { span: 6 },
    };
    const medicineTypeList = this.getMedicineTypeList();

    const orderTypeList = this.getOrderTypeList();

    return (
      <div>
        <div className="mall_top_title">
          <span className="mall_title_desc">{I18N.get('pharmacy_add')}</span>
          <div className="mall_title_right_button">
            <Button type="primary" onClick={this.goback}>
              {I18N.get('common_back')}
            </Button>
          </div>
        </div>

        <Form onSubmit={this.handleSubmit}>
          <Form.Item label={I18N.get('common_name_desc')} {...formItemLayout}>
            {getFieldDecorator(`name`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('common_name_desc')}`,
                },
                { type: 'string', max: 15, message: '最多输入15个字符' },
              ],
            })(
              <Input
                maxLength={15}
                minLength={1}
                name="pharmacy-name"
                placeholder={`${I18N.get('pharmacy_brand')}+${I18N.get('pharmacy_dosage_form')}+${I18N.get('pharmacy_location')}`}
              />
            )}
          </Form.Item>
          <Form.Item label={I18N.get('pharmacy_category')} {...formItemLayout}>
            {getFieldDecorator(`category`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_category')}`,
                },
              ],
            })(
              <Select onChange={this.categoryOnChange} placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_category')}`}>
                {categoryList.map((f) => {
                  return (
                    <Select.Option key={`${f.uuid}`} value={f.code}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label={I18N.get('pharmacy_brand')} {...formItemLayout}>
            {getFieldDecorator(`brand`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_brand')}`,
                },
              ],
            })(
              <Select placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_brand')}`}>
                {brandList.map((f) => {
                  return (
                    <Select.Option key={`${f.uuid}`} value={f.uuid}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label={I18N.get('pharmacy_dosage_form')} {...formItemLayout}>
            {/* 剂型 */}
            {getFieldDecorator(`dosage_form`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_dosage_form')}`,
                },
              ],
            })(
              <Select placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_dosage_form')}`}>
                {medicineTypeList.map((m) => {
                  return (
                    <Select.Option key={m.key} value={m.value}>
                      {I18N.get(m.key)}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label={I18N.get('order_category')} {...formItemLayout}>
            {getFieldDecorator(`order_type`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('order_category')}`,
                },
              ],
              // initialValue: '',
            })(
              <Select placeholder={`${I18N.get('common_choose')}${I18N.get('order_category')}`}>
                {orderTypeList.map((m) => {
                  return (
                    <Select.Option key={m.key} value={m.value}>
                      {I18N.get(m.key)}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
            <Button type="primary" htmlType="submit">
              {I18N.get('common_save')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const PharmacyAddComponent = Form.create<IPharmacyAddFormProps>()(PharmacyAddForm);
export default PharmacyAddComponent;



// WEBPACK FOOTER //
// ./src/components/views/Mall/PharmacyAdd.tsx